import { render, staticRenderFns } from "./EditHeadingBlockModal.vue?vue&type=template&id=6f909eec&lang=pug&"
import script from "./EditHeadingBlockModal.vue?vue&type=script&lang=js&"
export * from "./EditHeadingBlockModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports